import { redirect } from "react-router";
import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		index: true,
		loader: () => redirect(PAGES.communications.sub.emails),
	},
	{
		path: PAGES.communications.sub.emails,
		lazy: () =>
			import(
				"src/module--communications/pages/communications/email-communications.page"
			).then(convertFrameworkRoute),
	},
	{
		path: `${PAGES.communications.sub.emailDetails}`,
		lazy: () =>
			import(
				"src/module--communications/pages/communication/email-communication.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.sms,
		lazy: () =>
			import(
				"src/module--communications/pages/communications/sms-communications.page"
			).then(convertFrameworkRoute),
	},
	{
		path: `${PAGES.communications.sub.smsDetails}`,
		lazy: () =>
			import(
				"src/module--communications/pages/communication/sms-communication.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.webhooks,
		lazy: () =>
			import(
				"src/module--communications/pages/communications/webhook-communications.page"
			).then(convertFrameworkRoute),
	},
	{
		path: `${PAGES.communications.sub.webhookDetails}`,
		lazy: () =>
			import(
				"src/module--communications/pages/communication/webhook-communication.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.emailsInsights,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.CommunicationsEmailInsightsReport,
			})),
	},
	{
		path: PAGES.communications.sub.smsInsights,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.CommunicationsSmsInsightsReport,
			})),
	},
	{
		path: PAGES.communications.sub.webhooksInsights,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.CommunicationsWebhooksInsightsReport,
			})),
	},
	{
		path: PAGES.communications.sub.orderStatusPage,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.CommunicationsOrderStatusPageReport,
			})),
	},
	{
		path: PAGES.communications.sub.feedback,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.CommunicationsFeedbackReport,
			})),
	},
	{
		path: PAGES.communications.sub.emotionAIPromotion,
		lazy: () =>
			import(
				"src/module--communications/pages/emotion-ai-promotion.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.onDemandMessagingLanding,
		lazy: () =>
			import("src/module--admin/pages/OnDemandMessageLanding.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.communications.sub.emotionAI,
		lazy: () =>
			import(
				"src/module--communications/pages/emotion-ai-report.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.benchmarkingPromotion,
		lazy: () =>
			import(
				"src/module--communications/pages/benchmarking-promotion.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.benchmarking,
		lazy: () =>
			import(
				"src/module--communications/pages/benchmarking-report.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.communications.sub.campaignsAnalytics,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.CampaignsReport,
			})),
	},
];
